const sdkPromises = {};

function loadSDK(src, isReady) {
  if (isReady()) return Promise.resolve();
  if (sdkPromises[src]) return sdkPromises[src];

  sdkPromises[src] = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    const timeout = setTimeout(
      () => finish(new Error("Sign-in SDK timed out")),
      15000
    );

    function finish(error) {
      clearTimeout(timeout);
      script.onload = script.onerror = null;
      if (error) {
        script.remove();
        delete sdkPromises[src];
        reject(error);
      } else {
        resolve();
      }
    }

    script.src = src;
    script.async = true;
    script.onload = () =>
      finish(isReady() ? null : new Error("Sign-in SDK unavailable"));
    script.onerror = () => finish(new Error("Sign-in SDK failed to load"));
    document.head.appendChild(script);
  });

  return sdkPromises[src];
}

export async function initGoogle(element, onCredential) {
  await loadSDK(
    "https://accounts.google.com/gsi/client",
    () => !!window.google?.accounts?.id
  );
  if (!element || !element.isConnected) return;

  window.google.accounts.id.initialize({
    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    callback: (response) => onCredential(response.credential),
    auto_select: false,
  });

  window.google.accounts.id.renderButton(element, {
    type: "standard",
    theme: "outline",
    size: "large",
    text: "signin_with",
  });
}
